// extracted by mini-css-extract-plugin
export default {"tabList":"styles_tabList__Q4CqK"};